const CREATED_AT = 'createdAt';
const asArray = [CREATED_AT];

export default ({
	asArray,
	CREATED_AT
});
